/**
 * Nachladefehler erkennen und einmal selbst heilen.
 *
 * Alle Seiten ausser der Uebersicht werden erst beim Aufruf nachgeladen
 * (`app/routes.tsx`). Schlaegt das fehl, gibt es zwei Ursachen:
 *
 * 1. Die App wurde aktualisiert (`git pull`), der offene Tab kennt aber noch
 *    die alten Dateinamen - ein Neuladen behebt das.
 * 2. Der Server laeuft nicht (Terminal zu, Ruhezustand) - dann hilft Neuladen
 *    nicht, im Gegenteil: der Browser zeigt nur "Seite nicht erreichbar" und
 *    die App ist ganz weg. Deshalb wird vorher geprueft, ob er antwortet.
 */

/** Die Meldungen von Chrome, Firefox und Safari fuer fehlgeschlagene `import()`. */
const MUSTER = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /unable to preload css/i,
];

export function istNachladeFehler(error: unknown): boolean {
  const text = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  return MUSTER.some((m) => m.test(text));
}

const MERKER = 'ole-privat:nachgeladen';
/** Innerhalb dieser Zeit kein zweiter automatischer Neustart - keine Schleife. */
export const SPERRE_MS = 60_000;

/** Darf jetzt automatisch neu geladen werden? Merkt sich den Versuch. */
export function neustartErlaubt(jetzt: number = Date.now(), speicher: Pick<Storage, 'getItem' | 'setItem'> = sessionStorage): boolean {
  try {
    const zuletzt = Number(speicher.getItem(MERKER) ?? 0);
    if (jetzt - zuletzt < SPERRE_MS) return false;
    speicher.setItem(MERKER, String(jetzt));
    return true;
  } catch {
    // Ohne Speicher kein Schutz vor einer Schleife - dann lieber gar nicht.
    return false;
  }
}

/** Antwortet der Server, von dem die App kommt? */
export async function serverErreichbar(): Promise<boolean> {
  try {
    const antwort = await fetch(`${window.location.origin}${window.location.pathname}`, { cache: 'no-store' });
    return antwort.ok;
  } catch {
    return false;
  }
}
